<div class="row">
  <div class="col-lg-6">
  <nexus-card  [card_title]="'Edit Lease'">
      <nexus-card-body>
        <form [formGroup]="form">
          <nexus-form-row row_label="Address">
            <div *ngIf="customer_group_model?.group">
                    <span *ngIf="customer_group_model?.group?.address1">{{ customer_group_model.group.address1 }}</span>
                    <br *ngIf="customer_group_model?.group?.address1 && customer_group_model.group.address2" />
                    <span *ngIf="customer_group_model?.group?.address2">{{ customer_group_model.group.address2 }}</span>
                    <br *ngIf="(customer_group_model?.group?.address1 || customer_group_model.group?.address2) && (customer_group_model.group?.city || customer_group_model.group?.region || customer_group_model.group?.zip5)" />
                <span *ngIf="customer_group_model?.group?.city">{{ customer_group_model.group.city }}</span>
                <span *ngIf="customer_group_model?.group?.city && customer_group_model.group.region">, </span>
                <span *ngIf="customer_group_model?.group?.region">{{ customer_group_model.group.region.code }}</span>
                <span *ngIf="customer_group_model?.group?.region && customer_group_model.group.zip5">&nbsp;</span>
                <span *ngIf="customer_group_model?.group?.zip5" >{{ customer_group_model.group.zip5 }}</span>
            </div>
          </nexus-form-row>
          <nexus-form-row row_label="Lease Start Date">
            <kendo-datepicker class="form-control" [format]="'MM/dd/yyyy'" formControlName="start_date" style="min-width:75%"></kendo-datepicker>
          </nexus-form-row>
          <nexus-form-row row_label="Move Out Date" *ngIf="respect_move_out_dates">
            <div class="date-container">
                <kendo-datepicker class="form-control" [format]="'MM/dd/yyyy'" formControlName="move_out_date" style="min-width:75%"></kendo-datepicker>
                <ng-container *ngTemplateOutlet="warning_tooltip"></ng-container>
            </div>
          </nexus-form-row>
          <nexus-form-row row_label="Lease End Date" *ngIf="!respect_move_out_dates">
            <div class="date-container">
              <kendo-datepicker class="form-control" title="Closable tooltip content" [format]="'MM/dd/yyyy'" formControlName="end_date" style="min-width:75%"></kendo-datepicker>
              <ng-container *ngTemplateOutlet="warning_tooltip"></ng-container>
          </div>
          </nexus-form-row>
          <nexus-form-row control_id="modification-note-input" row_label="Modification Note">
            <textarea kendoTextArea class="form-control w-100" id="modification-note-input" formControlName="modification_note">
            </textarea>
          </nexus-form-row>
            <div class="footer">
              <a class="nav-link" (click)="navigate_to_groups()">Back</a>
              <button kendoButton icon="check" (click)="submit()" [primary]="true" [disabled]="!is_editable">Submit</button>
            </div>
        </form>
        <nexus-form-result [model]="form_result"></nexus-form-result>
    </nexus-card-body>
  </nexus-card>
  </div>
  </div>

  <ng-template #warning_tooltip>
    <div class="hover-text">
      <span class="tooltip-text tooltip-text-right" *ngIf="is_editable">Changing this date might impact your Final Billing. Please contact your Account Manager if you have any questions.</span>
      <span class="tooltip-text tooltip-text-right" *ngIf="!is_editable">Final Billing is in progress or has been completed for this Resident. Contact your Account Manager if a change needs to be made to the Move Out Date.</span>
    </div>
  </ng-template>
